module.exports = __webpack_public_path__ + "img/2021_2_15_half_woman_head.b22ecd52.jpg";